import { render, staticRenderFns } from "./ConsumptionDataExchangeIbaenergie.vue?vue&type=template&id=bbc88c9a&lang=pug&"
import script from "./ConsumptionDataExchangeIbaenergie.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionDataExchangeIbaenergie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports